import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { Button } from 'ui-components/components/button';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import asModal from '../../../../../../src/components/as-modal';
import messages from './messages';

import style from './style.module.less';

const RemoveRuleConfirmation = ({ onClose, onConfirm }) => {
  return (
    <Modal>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage {...messages.allocationRuleDeleteConfirmationHeader} />
      </ModalHeader>
      <ModalBody className={style['rule-deletion-modal']}>
        <FormattedMessage {...messages.allocationRuleDeleteConfirmationBody} />
      </ModalBody>
      <ModalFooter className={style.footer}>
        <Button className={style.cancel} onClick={onClose} theme='secondary'>
          <FormattedMessage {...messages.allocationRuleDeleteConfirmationCancel} />
        </Button>
        <Button className={style.action} onClick={onConfirm} theme='primary'>
          <FormattedMessage {...messages.allocationRuleDeleteConfirmationConfirm} />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

RemoveRuleConfirmation.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default asModal(RemoveRuleConfirmation);
